<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>Produtos </h1>
                <p class="info">Esta oportunidade é para você e seu negócio!</p>
            </div>
        </div>
        <b-container>
            <b-row class="pt-2">
                <b-col lg="3" md="12" sm="12" class="pt-2 mini-menu">
                    <b-nav vertical>
                        <b-nav-item v-for="categoria in categorias" :key="categoria.id" v-on:click="loadProducts(1, categoria.id)" href="javascript:void(0);">
                            {{categoria.nome}}
                        </b-nav-item>
                    </b-nav>
                </b-col>
                <b-col lg="9" md="12" sm="12" class="pt-2">
                    <div class="items">
                        <router-link v-for="produto in produtos" :key="produto.prdno.trim()" to="/seja-um-parceiro/acesso">
                            <div class="item col-lg-3 col-md-2 col-sm-1 text-center">
                                <img :src="produto.grades[0].url_miniatura" :alt="produto.grades[0].nome"
                                        class="img-item">
                                <div class="info text-justify">
                                    <h3>{{produto.nome}}</h3>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <b-pagination-nav v-if="totalPages >= 1" align="center" :link-gen="linkGen" :number-of-pages="totalPages" v-model="currentPage"/>
                </b-col>
                <br>

            </b-row>
            <!-- Content here -->
        </b-container>
    </div>
</template>
<style>
    .page-link {
        color: #c70000;
    }
    .page-item.active .page-link {
        background-color: #c70000;
        border-color: #c70000;
    }
    .page-link:focus, .page-link:hover{
        color: #c70000;
    }
</style>
<script>
    import axios from 'axios'

    export default {
        data: () => ({
            produtos: [],
            categorias: [],
            errors: [],
            currentPage: 0,
            totalPages: 0,
            first: true,
            currentCategory: null,
        }),
        methods: {
            linkGen(pageNum) {
                return 'javascript:void(0);';
            },
            loadProducts(pageNum = 1, cat = null) {
                let url = '/api/produtos?';

                if (pageNum) {
                    url += 'page=' + pageNum;
                }

                if (cat || this.currentCategory) {
                    this.currentCategory = cat;
                    url += '&categoria=' + this.currentCategory
                }
                axios.get(url)
                    .then(response => {
                        // JSON responses are automatically parsed.
                        if (undefined != response.data.data) {
                            this.produtos = response.data.data
                            this.totalPages = response.data.last_page
                            this.currentPage = response.data.current_page
                            return true;
                        }
                        this.produtos = response.data.produtos;
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
            }
        },
        watch: {
            currentPage(val) {
                if (this.first) {
                    this.first = false;
                    return true;
                }
                this.loadProducts(val, this.currentCategory)
            }
        },
        created() {
            this.loadProducts()
            axios.get('/api/categorias')
                .then(response => {
                    // JSON responses are automatically parsed.
                    this.categorias = response.data
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
    }
</script>



// WEBPACK FOOTER //
// Produtos.vue?a8169964